import React from 'react';
import * as Styles from './ProTag.styles';
import withErrorBoundary from '@/utils/errorBoundary';
import useLocale from '@/hooks/useLocale';
import { IconCrown } from '../Icons/IconCrown';

const CardFeatures = ({ position, size = 'medium' }) => {
  const { studio: studioLocale } = useLocale();

  return (
    <Styles.TagPro position={position} size={size}>
      <IconCrown size={size} />
      {studioLocale.highlightFeatures.tag.label}
    </Styles.TagPro>
  );
};
export default withErrorBoundary(CardFeatures, 'CardFeatures');
